import React, { useEffect, useState } from "react";
import ssoHandler from "./ssoHandler";
// import Loader from '../../components/Loader';
import { useAppServices } from "../../hook/services";
import env from "../../config";
import axios from "axios";
import Loader from "examples/Loader";
import localforage from "localforage";
const iframeStyles = {
  width: "100%",
  height: "100vh",
  border: "none",
};
const BASE_URL = `${env.API_URL}/v1`;
const SSOIframe = () => {
  const Service = useAppServices();
  const { SSO, checkSSO } = ssoHandler();
  const [ssodata, setssodata] = useState({});
  const [loader, setloader] = useState(true);
  const [IframeUrl, setIframeUrl] = useState("");
  const Agency_level = `${env.ACCOUNT_LEVEL_URL}`;
  const Account_level = `${env.ACCOUNT_LEVEL_URL}`;
  // const Account_level = `http://localhost:3004`;
  // alert(Account_level)
  useEffect(() => {
    checkSSO();
  }, []);
  useEffect(() => {
    console.log("SSOSSOSSOSSO", SSO);
    const fetchData = async () => {
      if (SSO && SSO !== "") {
        try {
          const data = JSON.parse(SSO);
          const token = await localforage.getItem("token");

          // Fetch agency data
          const { response } = await Service?.agency.GetByLocation({
            query: `location_id=${data?.activeLocation}`,
            token,
          });

          // Set iframe URL based on conditions
          if (data?.activeLocation) {
            setIframeUrl(`${Account_level}/${data?.email}/${data?.activeLocation}/dashboard`);
          } else {
            setIframeUrl(`${Account_level}/agency_custom_page/${data?.companyId}`);
          }
        } catch (error) {
          console.error("Error fetching data:", error); // Log any errors
        } finally {
          setloader(false); // Ensure loader is set to false
        }
      }
    };

    fetchData(); // Call the async function
  }, [SSO]);
  return (
    <div>
      {loader ? (
        <Loader />
      ) : (
        <>{IframeUrl != "" && <iframe style={iframeStyles} src={`${IframeUrl}`}></iframe>}</>
      )}
    </div>
  );
};

export default SSOIframe;
